import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import RoleBadge from "../RoleBadge";
import { useContacts } from "../../state/ContactContext";

const ViewContactDrawer = ({ showViewContactDrawer, handleClose }) => {
  const { selectedContact } = useContacts();

  const contactTypeOptions = [
    { label: "Regular and emergency", value: ["regular", "emergency"] },
    { label: "Regular", value: ["regular"] },
    { label: "Emergency", value: ["emergency"] },
  ];

  if (!selectedContact || !showViewContactDrawer) {return;}

  const contactTypeLabel =
    contactTypeOptions.find((opt) =>
      opt.value.every((val) => selectedContact.contactTypes?.includes(val)),
    )?.label || "—";

  return (
    <div
      className={`page-drawer-modal ${
        showViewContactDrawer ? "show-drawer" : ""
      }`}
    >
      <div className="page-drawer-container">
        <div className="pd-header">
          <h4>View Contact</h4>
        </div>

        <div className="pd-content">
          <div className="new-contact-container">
            <div className="view-role">
              <RoleBadge role={selectedContact?.contactRole || "caregiver"} />
            </div>

            <form className="inline-form form-with-text-values">
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <span className="form-text-value">
                  {selectedContact?.firstName || selectedContact?.first_name || ''}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <span className="form-text-value">
                  {selectedContact?.lastName || selectedContact?.last_name || ''}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <span className="form-text-value">{selectedContact.email}</span>
              </div>

              <div className="form-group">
                <label htmlFor="contactType">
                  <Tooltip title="Regular contacts can be contacted by your client one-by-one at any time. Emergency contacts can be contacted by your client in a repeated loop until one of them picks up.">
                    <InfoIcon />
                  </Tooltip>
                  Contact Type
                </label>
                <span className="form-text-value">{contactTypeLabel}</span>
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <span className="form-text-value">{selectedContact.phone}</span>
              </div>
            </form>
          </div>
        </div>

        <div className="pd-footer">
          <div className="filter-btns-group">
            <button type="button" onClick={handleClose}>
              Exit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewContactDrawer;
